





























































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import {
  AppUserChangePasswordEditModel,
  AppUserSettingsEditModel,
  MenuColorEnum,
  StSelectListItem,
  StStringSelectListItem,
  SuccessButtonColorEnum,
} from '@/services/api/nswag/stapiclient_generated';
import { stAppUserApi, stLookupApi } from '@/services/st-api';
import { UserStore } from '@/store/user-module';
import { TabModel } from '@/components/tabs/tab-model';
import StTabs from '@/components/tabs/StTabs.vue';
import StToggle from '@/components/basic/StToggle.vue';
import { notifySuccess } from '@/utlitities/notifications';
import SlideIn from '@/components/basic/SlideIn.vue';
import StSettingsSeparator from '@/components/basic/Form/StSettingsSeparator.vue';

@Component({
  components: { StSettingsSeparator, SlideIn, StToggle, StTabs },
})
export default class UserSettings extends Vue {
  userSettingsEditModel: AppUserSettingsEditModel = AppUserSettingsEditModel.fromJS({});
  timeZones: StSelectListItem[] = [];
  datePatterns: StStringSelectListItem[] = [];
  timePatterns: StStringSelectListItem[] = [];
  loading: boolean = true;
  saveLoading: boolean = false;
  activeTabName = 'standard';
  changePasswordEditModel: AppUserChangePasswordEditModel = AppUserChangePasswordEditModel.fromJS({});
  passwordType1 = 'password';
  passwordType2 = 'password';
  passwordType3 = 'password';
  changePasswordLoading = false;
  apiKey = 'Loading...';

  get tabs(): TabModel[] {
    return [
      {
        TabName: 'standard',
        Disabled: false,
      },
    ];
  }

  get templates(): any[] {
    return UserStore.templates;
  }

  get userCanApproveAbsences(): boolean {
    return UserStore.userSettings.CanApproveAbsences && UserStore.userSettings.useAbsences;
  }

  get timeRoundingIntervalOptions() {
    return [
      { value: 1, text: '1 min' },
      { value: 5, text: '5 min' },
      { value: 10, text: '10 min' },
      { value: 15, text: '15 min' },
      { value: 30, text: '30 min' },
    ];
  }

  get languages() {
    return [
      { value: 'de', text: 'Deutsch' },
      { value: 'en', text: 'English' },
    ];
  }

  async mounted() {
    try {
      this.loading = true;
      this.timeZones = await stLookupApi.getTimeZoneIds();
      this.datePatterns = await stLookupApi.getDatePattern();
      this.timePatterns = await stLookupApi.getTimePattern();
      await this.loadEditModel();
    } finally {
      this.loading = false;
    }
  }

  async loadEditModel() {
    this.userSettingsEditModel = await stAppUserApi.getAppUserSettingsEditModel();
  }

  async submit() {
    await stAppUserApi.storeAppUserSettings(this.userSettingsEditModel);
    await UserStore.reloadStore();
    notifySuccess('Erfolgreich gespeichert.');
  }

  get menuColors() {
    return [
      { id: MenuColorEnum.Dark, label: this.$t('Dunkel') },
      { id: MenuColorEnum.Light, label: this.$t('Hell') },
      { id: MenuColorEnum.Primary, label: this.$t('Hauptfarbe') },
      { id: MenuColorEnum.Secondary, label: this.$t('Akzentfarbe') },
    ];
  }

  get successButtonColors() {
    return [
      { id: SuccessButtonColorEnum.Green, label: this.$t('Grün') },
      { id: SuccessButtonColorEnum.Primary, label: this.$t('Hauptfarbe') },
      { id: SuccessButtonColorEnum.Secondary, label: this.$t('Akzentfarbe') },
    ];
  }

  get canChangeTimeFromTo() {
    return UserStore.userSettings.CanChangeTimeFromTo;
  }

  openChangePassword() {
    (this.$refs.changePassword as SlideIn).open();
  }

  cancelChangePassword() {
    (this.$refs.changePassword as SlideIn).close();
  }

  async openApiKey() {
    (this.$refs.apiKey as SlideIn).open();
    this.apiKey = await stAppUserApi.getCurrentUserApiKey();
  }

  cancelApiKey() {
    (this.$refs.apiKey as SlideIn).close();
  }

  async changePassword() {
    try {
      this.changePasswordLoading = true;
      await stAppUserApi.changePassword(this.changePasswordEditModel);
      this.changePasswordEditModel = AppUserChangePasswordEditModel.fromJS({});
      notifySuccess('Das Passwort wurde geändert');
      (this.$refs.changePassword as SlideIn).close();
    } finally {
      this.changePasswordLoading = false;
    }
  }

  copyApiKey() {
    (this as any).$clipboard(this.apiKey);
    notifySuccess('Erfolgreich kopiert');
  }
}
